import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  static values = {
    initialMarkers: { type: Array, default: [] }
  }

  connect() {
    this.markers = []
    this.initMap()

    // Listen for match:added events from the room controller
    this.boundAddMarker = this.handleMatchAdded.bind(this)
    document.addEventListener("match:added", this.boundAddMarker)

    // Listen for invalidate events (when container becomes visible)
    this.boundInvalidate = () => {
      if (this.map) this.map.invalidateSize()
    }
    document.addEventListener("map:invalidate", this.boundInvalidate)

    // Load initial markers (for page refresh on completed rooms)
    this.initialMarkersValue.forEach(m => {
      this.addMarker(m.lat, m.lng, m.date, m.distance, m.matchId)
    })

    // Invalidate size after initial render in case container was hidden
    setTimeout(() => { if (this.map) this.map.invalidateSize() }, 200)
  }

  disconnect() {
    document.removeEventListener("match:added", this.boundAddMarker)
    document.removeEventListener("map:invalidate", this.boundInvalidate)
    if (this.map) {
      this.map.remove()
    }
  }

  initMap() {
    this.map = L.map(this.element).setView([20, 0], 2)

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(this.map)

    // Fix Leaflet icon paths (broken with bundlers)
    delete L.Icon.Default.prototype._getIconUrl
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
      iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
      shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png"
    })
  }

  handleMatchAdded(event) {
    const { lat, lng, date, distance, matchId } = event.detail
    this.addMarker(lat, lng, date, distance, matchId)
  }

  addMarker(lat, lng, date, distance, matchId) {
    if (!this.map) return

    const dateStr = new Date(date + "T00:00:00").toLocaleDateString("en-US", {
      year: "numeric", month: "long", day: "numeric"
    })

    const marker = L.marker([lat, lng]).addTo(this.map)
    marker.bindPopup(`<strong>${dateStr}</strong><br>${Math.round(distance)}m apart`)
    this.markers.push(marker)

    // Auto-fit bounds
    if (this.markers.length === 1) {
      this.map.setView([lat, lng], 13)
    } else {
      const group = L.featureGroup(this.markers)
      this.map.fitBounds(group.getBounds().pad(0.1))
    }
  }
}
